<template>
  <DxDataGrid
    id="subGrid"
    :ref="subGridRef"
    :rtl-enabled="rtlEnabled"
    :data-source="dataStore"
    :remote-operations="true"
    :showBorders="false"
    :columnAutoWidth="true"
    :allowColumnReordering="true"
    :allowColumnResizing="true"
    :rowAlternationEnabled="false"
    :showColumnLines="true"
    :showRowLines="true"
    :focusedRowEnabled="true"
    class="dashboardMasterGrid"
    keyExpr="id"
    :columns="subVisitHistoryGridColumns"
  >
    <DxPaging :page-size="1000" />
    <DxScrolling mode="standard" :use-native="!rtlEnabled"/>
    <template #notes-visit-history-cell="{ data }">
      <div style="white-space: normal; overflow-wrap: break-word; height: 90; width: 90">
        {{ data.value }}

        <a
          class="read_more"
          style="cursor: pointer"
          v-if="
            data.data.originalVisitNotes &&
            data.data.originalVisitNotes.length > 37 &&
            data.data.originalVisitNotes !== '-'
          "
          @click="changeFullText(data.data, true)"
        >
          Read {{ data.data.showingFullText ? "Less" : "More" }}
        </a>
      </div>
    </template>

    <template #status-visit-history-cell="{ data }">
      <div>
        <!-- DENIED & AUTO SIGNED OUT & DELETED STATUS -->
        <div class="d-flex align-items-center" style="position: relative;"
        v-if="data.data.data_type_id == 5 || data.data.data_type_id == 8"
        > 
          <span class="text-red font-weight-bolder">{{
            data.data.scan_data_type_name
          }}</span>

          <svg
          tabindex="0"
          v-b-tooltip
          :id="data.data.id"
          style="margin-inline-start: 8px; outline: none"
          width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z" fill="#787878"/>
          </svg>

          <b-tooltip placement="righttop" :target="data.data.id" triggers="click blur">
            {{ data.data && data.data.failed_message ? data.data.failed_message : "-" }}
          </b-tooltip>
        </div>

        <!-- AUTO SIGNED IN STATUS -->
        <div class="d-flex align-items-center" v-else-if="data.data.data_type_id == 9 || (data.data.data_type_id === '1' && data?.data?.failed_message)">
          <span class="text-green font-weight-bolder">
            {{ data.data.scan_data_type_name }}</span
          >
          <svg
            tabindex="0"
            v-b-tooltip
            :id="data.data.id"
            style="margin-inline-start: 8px; outline: none"
            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z" fill="#787878"/>
          </svg>

          <b-tooltip placement="bottomright" :target="data.data.id" triggers="click blur">
            {{ data.data && data.data.failed_message ? data.data.failed_message : "-" }}
          </b-tooltip>
        </div>

        <!-- SIGNED OUT & VISIT REJECTED & VISIT DELETED STATUS -->
        <div class="d-flex align-items-center"
          v-else-if="
            data.data.data_type_id == 4 ||
            data.data.data_type_id == 15 ||
            data.data.data_type_id == 12
          "
        >
          <span class="text-red font-weight-bolder">{{
            data.data.scan_data_type_name
          }}</span>
        </div>

        <!-- VISIT UPDATED STATUS -->
        <div class="d-flex align-items-center" v-else-if="data.data.data_type_id == 10">
          <span>{{ data.data.scan_data_type_name }}</span>
          <svg
            tabindex="0"
            v-b-tooltip
            :id="data.data.id"
            style="margin-inline-start: 8px; outline: none"
            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z" fill="#787878"/>
          </svg>
          <b-tooltip placement="bottomright" :target="data.data.id" triggers="click blur">
            {{ data.data && data.data.failed_message ? data.data.failed_message : "-" }}
          </b-tooltip>
        </div>

        <!-- COMPLIANCE FILLED IN STATUS -->
        <div class="d-flex align-items-center" v-else-if="data.data.data_type_id == 13">
          <span>{{ data.data.scan_data_type_name }}</span>
          <svg
            tabindex="0"
            v-b-tooltip.html
            :id="data.data.id"
            style="margin-inline-start: 8px; outline: none"
            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z" fill="#787878"/>
          </svg>
          <b-tooltip placement="bottomright" :target="data.data.id" triggers="click blur">
            <ul style="margin-bottom: unset">
              <li
                v-for="(msg, index) in data.data.failed_message"
                :key="index"
                class="tool-customization"
              >
                {{ msg }}
                <div v-if="index != data.data.failed_message.length - 1" class="tooltip-separator"></div>
              </li>
            </ul>
          </b-tooltip>
        </div>

        <!-- NO SHOW VISIT STATUS -->
        <div class="d-flex align-items-center" v-else-if="data.data.data_type_id == 7">
          <span style="font-weight: 700; font-size: 16px; color: #000000">{{
            data.data.scan_data_type_name
          }}</span>
          <svg
            tabindex="0"
            v-b-tooltip
            :id="data.data.id"
            style="margin-inline-start: 8px; outline: none"
            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z" fill="#787878"/>
          </svg>
          <b-tooltip placement="bottomright" :target="data.data.id" triggers="click blur">
            {{ data.data.failed_message ? data.data.failed_message : "-" }}
          </b-tooltip>
        </div>

        <!-- EXPECTED VISIT STATUS -->
        <div class="d-flex align-items-center" v-else-if="data.data.data_type_id == 6">
          <span class="text-warning font-weight-bolder">{{
            data.data.scan_data_type_name
          }}</span>
        </div>

        <!-- ADDED AS EXPECTED STATUS -->
        <div class="d-flex align-items-center" v-else-if="data.data.data_type_id == 11 || data.data.data_type_id == 18">
          <span>{{ data.data.scan_data_type_name }}</span>
        </div>

        <!-- VISIT APPROVED STATUS -->
        <div class="d-flex align-items-center" v-else-if="data.data.data_type_id == 14">
          <span style="font-weight: 700; font-size: 16px; color: #2680eb">{{
            data.data.scan_data_type_name
          }}</span>
        </div>

        <div v-else class="d-flex align-items-center text-green font-weight-bolder">
          {{ data.data.scan_data_type_name }}
        </div>
      </div>
    </template>

    <template #image-visit-history-cell="{ data }">
      <div v-viewer class="images dash-img clearfix">
        <ImageCell
          v-if="!data.data.scan_image"
          :image="data.data.scan_image"
          :name="visit.first_name ? visit.first_name.charAt(0) : ''"
        />
        <img
          class="img-fluid rounded-circle"
          v-if="data.data.scan_image"
          style="cursor: pointer"
          :src="data.data.scan_image"
        />
      </div>
    </template>

    <template #temperature-visit-history-cell="{ data }">
      <div class="float-left">
        <span v-if="data.value == '-'" class="dash-normal-color font-weight-bolder">{{
          data.value
        }}</span>
        <span
          v-else
          class="font-weight-bolder"
          :class="data.data.failedKey == 'high_temperature' ? 'text-red' : 'text-green'"
          >{{ data.value }}</span
        >
      </div>
    </template>

    <template #mask-visit-history-cell="{ data }">
      <span
        :class="
          data.data.has_mask == 'Yes'
            ? 'text-green'
            : data.data.has_mask == 'No'
            ? 'text-red'
            : 'dash-normal-color'
        "
        class="font-weight-bolder"
        >{{ data.data.has_mask }}</span
      >
    </template>

    <template #compliance-visit-history-cell="{ data }">
      <div class="dash-comp">
        <CompliancesCell
          :scan="visit"
          :data="data.value"
          :user_id="visit.user_id"
          :visit_id="visit.id"
          :entity_id="visit.entity_id"
          :scan_id="data.data.id"
        />
      </div>
    </template>

    <template #Location-visit-history-cell="{ data }">
      <div class="dash-comp">
        <LocationCell :location="data.data.location" />
      </div>
    </template>

    <template #document-visit-history-cell="{ data }">
      <span
        class="text-capitalize cursor-pointer"
        @click="
          data.data.document_status != 'Not Applicable' &&
            data.data.document_status != '-' &&
            setUserData(data.data)
        "
        v-b-modal="
          data.data.document_status != 'Not Applicable' &&
          data.data.document_status != '-' &&
          'vaccineDetailsModal'
        "
        :class="renderVaccineDocumentColor(data.data.document_status)"
        >{{ data.data.document_status }}
      </span>
    </template>

    <template #visitHistoryCustomField-template="{ data }">
      <span v-if="!data.value">-</span>

      <span v-else-if="getCustomFieldData(data).type == 'checkboxes'">{{ getCheckboxVal(data.value) }}</span>

      <span v-else-if="getCustomFieldData(data).type == 'toggleButton'">{{ +data.value ? "Yes" : "No" }}</span>

      <template v-else-if="getCustomFieldData(data).type == 'ratingScale' && getCustomFieldData(data).metadata[0].show_as == 'smileys'">
        <div class="d-flex align-items-center" style="gap: 8px">
          <div class="grid-smiley-container">
            <div class="d-flex align-items-center" style="margin-inline-end: -1px;">
              <span class="svg-div" v-html="getRatingScaleData(data).smileySvg"></span>
            </div>
          </div>
          <p class="smiley-text"
              :style="{color: getRatingScaleData(data).smileyColor}">{{ getRatingScaleData(data).smileyText }}</p>
        </div>
      </template>

      <template v-else-if="getCustomFieldData(data).type == 'ratingScale' && getCustomFieldData(data).metadata[0].show_as == 'stars'">
        <div style="display: flex;">
          <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 25.4465L6.993 29.8547C6.13663 30.3242 5.13656 29.5678 5.29908 28.5701L6.83048 19.2321L0.354854 12.6197C-0.338965 11.9155 0.0423195 10.683 0.998661 10.5395L9.9495 9.17663L13.9561 0.679814C14.3812 -0.226605 15.6188 -0.226605 16.0501 0.679814L20.0505 9.17663L29.0013 10.5395C29.9577 10.683 30.3389 11.9155 29.6452 12.6197L23.1695 19.2321L24.701 28.5701C24.8634 29.5678 23.8634 30.3308 23.007 29.8547L15 25.4465Z" fill="#103F5E"/>
          </svg>
          <span class="rating-star"
          :style="{ marginInlineStart: data.value > 9 ? '-18px' : '-15px'}">{{ Number(data.value) }}</span>
        </div>
      </template>

      <template v-else-if="getCustomFieldData(data).type == 'ratingScale' && getCustomFieldData(data).metadata[0].show_as == 'labels'">
        <div class="rating-label-container">
          <span class="rating-label"
          :style="{ marginInlineStart: data.value > 9 ? '24%' : '36%'}">{{ Number(data.value) }}</span>
        </div>
      </template>

      <span v-else>{{ data.value }}</span>
    </template>

    <template #visit-history-action-cell="{data}">
      <div>
        <VpButton v-if="data.data.editable"
        :text="$t('common.edit')"
        width="70px"
        height="27px"
        radius="4px"
        @click="setScanCustomFieldModalData(data.data.id)"  />
        <span v-else>-</span>
      </div>
    </template>

  </DxDataGrid>
</template>

<script>
// import Vue from "vue";
import moment from "moment";

import { mapActions, mapGetters } from "vuex";
import DxDataGrid, { DxPaging, DxScrolling } from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import LocationCell from "@/components/dashboard/LocationCell";
import CompliancesCell from "@/components/dashboard/CompliancesCell";
import ImageCell from "@/components/sharedCells/ImageCell";
import { deletedUserMixin } from "@/utils/mixins/deletedUserMixin";
import store from "@/state/store";
import smileysJson from "@/router/views/customFields/smileys.json";

// import { createStore } from 'devextreme-aspnet-data-nojquery';

import Api from "../../../services/Api";

const subGridRef = "dataGrid";

// function isNotEmpty(value) {
//   return value !== undefined && value !== null && value !== "";
// }

export default {
  mixins: [deletedUserMixin],

  components: {
    LocationCell,
    CompliancesCell,
    ImageCell,
    DxDataGrid,
    // DxColumn,
    DxPaging,
    DxScrolling
  },
  props: ["visit", "isDeletedUser", "isArchivedUser", "selectedTemp"],
  data() {
    return {
      rtlEnabled: false,
      subGridRef,
      dataSource: [],
      needUpdateScrollPosition: true,
      dataStore: new CustomStore({
        // key: 'id',
        key: "id",
        load: () => {
          // let params = "?";
          // let filterQuery = "";
          // let sortObject = { sortField: null, sortOrder: "" };
          [
            "skip",
            "take",
            "requireTotalCount",
            "requireGroupCount",
            "sort",
            "filter",
            "totalSummary",
            "group",
            "groupSummary",
          ];

          return Api()
            .get(`/scans/${this.visit.id}`)
            .then((data) => {
              // console.log("masterdata", data);
              let scans = [];
              let entity = store.getters["authfack/currentEntity"];

              data.data.scans.map((scan) => {
                // console.log('scannn', scan);
                let degree = this.selectedTemp == "c" ? scan.temperature : scan.temperature * (9 / 5) + 32;
                
                const isHostDeletedUser = scan.host_name && scan.host_name.includes("Deleted");
                scans.push({
                  id: scan.id,
                  metadata: scan.metadata,
                  scan_data_type_name: scan.scan_data_type_name ?? "-",
                  scan_image: scan.scan_image,
                  location: scan.location,
                  area_name: scan.area_name ?? "-",
                  host_name: isHostDeletedUser
                      ? "Deleted User"
                      : scan.host_name ?
                      // scan.host_user.deleted_at
                        // ? "-" :
                        scan.host_name +
                          " (" +
                          (scan.host_userType
                            ? scan.host_userType
                            : "-") +
                          ")"
                      : "-",
                  device_name: scan.device_name ?? "-",
                  // don't show if visit status is expected(6), no show(7), added as expected(11),
                  input_method_name:
                    //  approved(14), or rejected(15)
                    scan.data_type_id == 6 ||
                    scan.data_type_id == 7 ||
                    scan.data_type_id == 11 ||
                    scan.data_type_id == 14 ||
                    scan.data_type_id == 15 ||
                    (scan.data_type_id == 13 && scan.action_by.type == "User")
                      ? "-"
                      : scan
                      ? scan.input_method_name == "Touch mode"
                        ? "Kiosk touchscreen"
                        : scan.input_method_name // touch mode(id=6)
                      : "-",
                  action_by: scan.action_by,
                  attendance_code: scan.attendance_code ?? "-",
                  reason_name: scan.reason_name ?? "-",
                  data_type_id: scan.data_type_id,
                  temperature:
                    // comp filled in(13), approved(14), or rejected(15)
                    (scan.data_type_id == 6 &&
                      scan.journey_stage != "waiting_for_admin_approval") ||
                    scan.data_type_id == 7 ||
                    scan.data_type_id == 11 ||
                    scan.data_type_id == 13 ||
                    scan.data_type_id == 14 ||
                    (scan.data_type_id == 5 &&
                      this.visit.user_id.includes("undefined")) ||
                    scan.data_type_id == 8 ||
                    scan.data_type_id == 15 ||
                    !degree || !scan.temperature
                      ? "-"
                      : 
                      // scan && this.selectedTemp ?
                      this.getRowTemp(scan) +
                        (this.selectedTemp == "f" ? " °F" : " °C"),
                      // : Math.round(degree * 10) / 10 +
                      //   (entity &&
                      //   entity.setting &&
                      //   entity.setting.length > 0 &&
                      //   entity.setting[0].pivot.value == "f"
                      //     ? " °F"
                      //     : " °C"),
                  failedKey: scan.failed_key,
                  failed_message: scan.failed_message,
                  journey_stage_text:
                    scan.data_type_id == 5 ? "-" : scan.journey_stage_text,
                  has_mask:
                    // comp filled in(13), approved(14), or rejected(15)
                    (scan.data_type_id == 6 &&
                      scan.journey_stage != "waiting_for_admin_approval") ||
                    scan.data_type_id == 7 ||
                    scan.data_type_id == 11 ||
                    scan.data_type_id == 13 ||
                    scan.data_type_id == 18 || // compliance re-sent
                    scan.data_type_id == 14 ||
                    scan.data_type_id == 15
                      ? "-"
                      : scan.has_mask == 1
                      ? "Yes"
                      : scan.has_mask == 0
                      ? "No"
                      : "-",
                  has_compliances:
                  (scan.data_type_id == 5 && Array.isArray(scan.failed_message) && scan.failed_message[0] != 'wrong_answer') || // denied
                    scan.data_type_id == 8 || // auto signed out
                    scan.data_type_id == 4 || // signed out
                    scan.data_type_id == 13 || // comp filled in
                    scan.data_type_id == 10 || // visit updated
                    scan.data_type_id == 11 // added as expected
                      ? "-"
                      : scan.has_compliances || scan.has_document
                      ? "expected"
                      : scan.has_compliances,
                  document_status: scan.has_document
                    ? scan.document_status
                    : "Not Applicable",
                  unit:
                    scan && scan.temperature_type
                      ? scan.temperature_type
                      : entity.setting &&
                        entity.setting.length > 0 &&
                        entity.setting[0].pivot.value,
                  deg: Math.round(degree * 10) / 10,
                  defaultUnit:
                    scan && scan.temperature_type
                      ? scan.temperature_type == "f"
                        ? " °F"
                        : " °C"
                      : entity.setting &&
                        entity.setting.length > 0 &&
                        entity.setting[0].pivot.value == "f"
                      ? " °F"
                      : " °C",
                  defaultUnitType:
                    scan && scan.temperature_type
                      ? scan.temperature_type
                      : entity.setting &&
                        entity.setting.length > 0 &&
                        entity.setting[0].pivot.value,
                  notes: scan.notes ? this.trimText(scan.notes, false) : "-",
                  originalVisitNotes: scan.notes ?? "-",
                  showingFullText: false,
                  scan_time: scan.scan_time
                    ? 
        (this.getLanguage === "ar" ?
         moment
          .utc(scan.scan_time)
          .tz(moment.tz.guess())
          .locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm") + 
          (moment.utc(scan.scan_time).tz(moment.tz.guess()).format("A") === "AM" ? " ص" : " م")
          : moment
                  .utc(scan.scan_time)
                  .tz(moment.tz.guess())
                  .format("DD/MM/YYYY - hh:mm:ss A"))
                    : "-",
                  customFields : scan.customFields,
                  customField_type : scan.customField_type,
                  customField_metadata : scan.customField_metadata,
                  editable : scan.editable
                });
              });

              return {
                data: scans,
                totalCount: data.data.totalCount,
                // summary: data.data.summary,
                // groupCount: data.data.groupCount,
              };
            })
            .catch((err) => {
              throw new Error(err);
            });
        },
      }),
      visitHistoryFields: [
        {
          dataField: "scan_image",
          cssClass: "dash-imgPosition",
          caption: this.$t("common.image"),
          id: "ScanImage",
          cellTemplate: "image-visit-history-cell",
          allowFiltering: false,
          allowEditing: false,
          allowSorting: false,
        },
        {
          dataField: "scan_data_type_name",
          caption: this.$t("common.grid.action"),
          cellTemplate: "status-visit-history-cell",
        },
        {
          dataField: "action_by",
          caption: this.$t("common.by"),
          calculateCellValue: this.calculateActionBy,
        },
        {
          dataField: "attendance_code",
          caption: this.$t("common.attendanceCode"),
          // width: "400",
          cssClass: "attendanceCodeColumn",
          dataType: "string",
          allowHeaderFiltering: false,
          allowFiltering: false,
          visible: true,
        },
        {
          dataField: "reason_name",
          caption: this.$t("dashboard.grid.reason"),
          dataType: "string",
          allowHeaderFiltering: false,
          allowFiltering: false,
        },
        {
          dataField: "scan_time",
          caption: this.$t("common.at"),
        },
        {
          dataField: "journey_stage_text",
          caption: this.$t("dashboard.grid.journeyStage"),
        },
        {
          dataField: "area_name",
          caption: this.$t("common.area"),
        },
        {
          dataField: "host_name",
          caption: this.$t("common.host"),
        },
        {
          dataField: "device_name",
          caption: this.$t("common.device"),
        },
        {
          dataField: "input_method_name",
          caption: this.$t("common.input"),
        },
        {
          dataField: "temperature",
          caption: this.$t("common.temperature"),
          cellTemplate: "temperature-visit-history-cell",
        },
        {
          dataField: "has_mask",
          cellTemplate: "mask-visit-history-cell",
          caption: this.$t("dashboard.grid.hasAMask"),
        },
        {
          dataField: "has_compliances",
          caption: this.$t("common.compliance"),
          cellTemplate: "compliance-visit-history-cell",
          allowFiltering: false,
        },
        {
          dataField: "document_status",
          caption: this.$t("dashboard.grid.vaccineDoc"),
          cellTemplate: "document-visit-history-cell",
        },
        {
          dataField: "location",
          caption: this.$t("common.location"),
          visible: "data.data.showLocation",
          cellTemplate: "Location-visit-history-cell",
        },
        {
          dataField: "notes",
          caption: this.$t("common.notes.notes"),
          // width: "250",
          cellTemplate: "notes-visit-history-cell",
        },
      ],
      isShowActionCell : false,
      visitStatus : '',
      visitHistoryCustomFields : [],
      smileysToShow: [
        ["sad", "happy"],
        ["sad", "poker", "happy"],
        ["sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
        ],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "frown",
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
      ],
    };
  },
  beforeMount() {
    if (this.getLanguage == 'ar') {
      this.rtlEnabled = true;
    }
    // this.$emit("setUpdateScroll");
  },
  mounted() {
    // console.log("master", this.visit);
    this.fetchScansOfVisit(this.visit.id).then((data) => {
      this.visitStatus =data.data.visit_status;
      this.isShowActionCell = data.data.actions_column && !this.isLitePlan ? true : false;
      this.visitHistoryCustomFields = data.data.customFields;
    })
  },
  computed: {
    ...mapGetters("grid", ["getTableHeaders"]),
    ...mapGetters("dailyLogbook", ["getSelectedTemp"]),
    ...mapGetters("authfack", ["getCurrentPlan"]),
    ...mapGetters("i18N",["getLanguage"]),
    subVisitHistoryGridColumns() {
      const fields = this.visitHistoryFields.map((field) => {
        let column = {
          dataField: field.dataField,
          caption: field.caption,
          // width: field.width,
          alignment: "start",
          allowFiltering: false,
          allowEditing: false,
          allowHeaderFiltering: false,
          allowSorting: false,
          showInColumnChooser: field.showInColumnChooser,
          cssClass: field.cssClass,
          allowExporting: false,
          visible: true,

          visibleIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find((item) => item.dataField == field.dataField)
              .visibleIndex,
          sortOrder:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find((item) => item.dataField == field.dataField)
              .sortOrder,
          sortIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find((item) => item.dataField == field.dataField)
              .sortIndex,
          calculateCellValue: field.calculateCellValue,
        };
        // console.log('column', column);
        if (field.cellTemplate) {
          column.cellTemplate = field.cellTemplate;
        }
        return column;
      });

      const hideOptional = this.visitStatus != 'old_visit' && (this.isDeletedUser || this.isArchivedUser);
      this.visitHistoryCustomFields.forEach((field) => {
        let obj = {
          dataField: `customFields.${field.id}`,
          caption: field.is_mandatory || (this.visitStatus == 'old_visit' && this.visit.data_type_id != 3 && this.visit.data_type_id != 9) || this.isLitePlan
            ? field.type == "ratingScale" &&
              (field.metadata[0].show_as == "stars" ||
                field.metadata[0].show_as == "labels")
              ? `${field.name} (Out of ${field.metadata[0].scale_count})` 
              : field.name
            : field.type == "ratingScale" &&
              (field.metadata[0].show_as == "stars" ||
                field.metadata[0].show_as == "labels")
            ? `${field.name} (Out of ${field.metadata[0].scale_count})${ !hideOptional ? this.$t('common.optionalWithBrackets') : ''}`
            : `${field.name}${ !hideOptional ? this.$t('common.optionalWithBrackets') : ''}`,

          allowFiltering: true,
          showInColumnChooser: true,
          allowExporting: false,
          allowHeaderFiltering:
            field.type == "ratingScale" || field.type == "toggleButton",
          filterOperations: this.allowedOperations,
          allowSorting: false,
          alignment: "start",
          // width: "230",
          visible:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            (this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).visible ||
              this.getTableHeaders.columns?.find(
                (item) => item.dataField == `customFields.${field.id}`
              ).visible == false)
              ? this.getTableHeaders.columns?.find(
                  (item) => item.dataField == `customFields.${field.id}`
                ).visible
              : true,
        };
        // if (field.type === "date") obj.cellTemplate = "date-visit-history-template";
        if (field.type === "toggleButton") {
          // obj.cellTemplate = "toggle-visit-history-template";
          obj.headerFilter = {
            dataSource: this.toggleHeaderFilter,
          };
        } else if (field.type === "ratingScale") {
        //   obj.cellTemplate = `${field.metadata[0].show_as}-visit-history-template`;
          obj.cssClass = field.metadata[0].show_as + field.metadata[0].scale_count;
        }
        // else if (field.type == "checkboxes") {
        //   obj.cellTemplate = "checkboxes-visit-history-template";
        // } else
        obj.cellTemplate = "visitHistoryCustomField-template";
        fields.push(obj);
      });

      fields.push({
        dataField : "Actions",
        caption : this.$t("common.grid.actions"),
        width : "118",
        allowSorting : false,
        allowFiltering : false,
        allowExporting : false,
        allowEditing : false,
        visible : this.isShowActionCell,
        cssClass : "select-actions select-actionsDAsh",
        cellTemplate : "visit-history-action-cell",
      });

      return fields;
    },
    isLitePlan() {
      return this.getCurrentPlan == 1;
    },
    subGrid() {
      return this.$refs[this.subGridRef].instance;
    },
  },
  watch: {
    selectedTemp(temp) {
      console.log('selectedTemp', temp);
      this.changeTemp(temp);
    },
  },
  methods: {
    ...mapActions("modal", ["setData"]),
    ...mapActions("dailyLogbook", ["fetchScansOfVisit"]),
    // contentReady(e) {
      // if (this.needUpdateScrollPosition) {
        // console.log('sub needUpdateScrollPosition', e);
      //   const scrollable = e.component.getScrollable();
      //   const maxScrollLeft = scrollable.scrollWidth();
      //   console.log('sub', scrollable, maxScrollLeft);

      //   scrollable.scrollTo({
      //     x: 100 // 2656
      //   });

      //   this.needUpdateScrollPosition = false;
      // }
    // },
    getRowTemp(row) {
      if (this.selectedTemp == "c") {
        if (row.temperature >= 30 && row.temperature <= 45) return row.temperature;
        const degree = row.temperature;
        const deg = (degree - 32) * (5 / 9);
        const tempInC = Math.round(deg * 10) / 10;
        return tempInC;
      } else {
        if (row.temperature >= 86 && row.temperature <= 113) return row.temperature;
        const degree = row.temperature * (9 / 5) + 32;
        const deg = Math.round(degree * 10) / 10;
        const tempInF = Math.round(deg * 10) / 10;
        return tempInF;
      }
    },
    changeTemp() {
      this.subGrid.getDataSource()._items.map((row) => {
        if (row.temperature !== "-") row.temperature = this.getRowTemp(row);
      });
      this.subGrid.refresh();
    },
    getCustomFieldData(data) {
      // console.log('getCustomFieldData', data);
      const customFieldId = data.column.dataField.split('.')[1];
      const customFieldType = data.data.customField_type[customFieldId];
      // console.log('customFieldType', customFieldType);
      return {
        type: customFieldType,
        metadata: data.data.customField_metadata[customFieldId]
      };
    },
    setUserData(data) {
      this.setData({
        type: "report_document",
        data,
      });
    },
    renderVaccineDocumentColor(type) {
      switch (type) {
        case "Vaccinated":
          return "text-primary font-weight-bolder";
        case "Not Applicable":
          return "text-secondary";
        case "Expired":
          return "text-warning font-weight-bolder";
        case "Negative PCR":
          return "text-success font-weight-bolder";
        default:
          return "text-danger font-weight-bolder";
      }
    },
    calculateActionBy(rowData) {
      let actionBy =
        rowData.action_by && rowData.data_type_id != 6 ? rowData.action_by : "-";
      try {
        const type = actionBy.type;
        if (type == "Admin" || type == "admin") return type + " - " + actionBy.fullName;
        else return type ? type : "-";
      } catch (e) {
        return "-";
      }
    },
    changeFullText(data, sub) {
      // console.log('changeFullText', data.id);
      const newNotes = this.trimText(data.originalVisitNotes, !data.showingFullText);
      if (sub) {
        data.notes = newNotes;
        data.showingFullText = !data.showingFullText;
        this.subGrid
          .getDataSource()
          .store()
          .push([
            {
              type: "update",
              key: { id: data.id },
              data: {
                showingFullText: !data.showingFullText,
                notes: newNotes,
              },
            },
          ]);
      } else {
        this.dataGrid
          .getDataSource()
          .store()
          .push([
            {
              type: "update",
              key: { id: data.id },
              data: {
                showingFullText: !data.showingFullText,
                visitNotes: newNotes,
              },
            },
          ]);
      }
    },
    trimText(data, showingFullText) {
      if (showingFullText) {
        return data;
      }
      return data && data !== "-" && data.length > 37
        ? `${data.slice(0, 37).trim()}...`
        : data;
    },
    getRatingScaleData(data) {
      let customFieldId;
      customFieldId = data.column.dataField.split('.')[1];
      const smileyColors = this.setSmileysColor(data.data.customField_metadata[customFieldId][0].scale_count);
      const smileyText = this.setSmileysText(data.data.customField_metadata[customFieldId][0].scale_count);
      const visibleSmiley = this.smileysToShow[data.data.customField_metadata[customFieldId][0].scale_count - 2];
      return {
        smileySvg: smileysJson[visibleSmiley[+data.value - 1] + 'Colored'],
        smileyColor: smileyColors[+data.value - 1],
        smileyText: smileyText[+data.value - 1]
      };
    },
    setSmileysColor(scaleCount) {
      let smileyColors = [];
      switch (scaleCount) {
        case 2:
          smileyColors = ["rgb(230, 10, 62)", "rgb(25, 179, 148)"];
          break;
        case 3:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(255, 152, 20)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 4:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(246, 104, 34)",
            "rgb(178, 161, 62)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 5:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(242, 81, 41)",
            "rgb(255, 152, 20)",
            "rgb(140, 165, 84)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 6:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(240, 66, 45)",
            "rgb(250, 123, 28)",
            "rgb(209, 157, 45)",
            "rgb(117, 168, 96)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 7:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(238, 57, 48)",
            "rgb(246, 104, 34)",
            "rgb(255, 152, 20)",
            "rgb(178, 161, 62)",
            "rgb(101, 170, 105)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 8:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(237, 50, 50)",
            "rgb(244, 91, 38)",
            "rgb(251, 131, 26)",
            "rgb(222, 155, 38)",
            "rgb(156, 163, 74)",
            "rgb(90, 171, 111)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 9:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(236, 45, 51)",
            "rgb(242, 81, 41)",
            "rgb(248, 116, 30)",
            "rgb(255, 152, 20)",
            "rgb(197, 158, 52)",
            "rgb(140, 165, 84)",
            "rgb(82, 172, 116)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 10:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(235, 41, 52)",
            "rgb(241, 73, 43)",
            "rgb(246, 104, 34)",
            "rgb(252, 136, 24)",
            "rgb(229, 155, 34)",
            "rgb(178, 161, 62)",
            "rgb(127, 167, 91)",
            "rgb(76, 173, 119)",
            "rgb(25, 179, 148)",
          ];
          break;
      }

      return smileyColors;
    },
    setSmileysText(scaleCount) {
    let smileyText = [];
    switch (scaleCount) {
      case 3:
        smileyText = [
          "Poor",
          "OK",
          "Good",
        ];
        break;
      case 5:
        smileyText = [
          "Bad",
          "Poor",
          "OK",
          "Good",
          "Great",
        ];
        break;
    }
    return smileyText;
    },
    getCheckboxVal(data) {
      const parsedArray = JSON.parse(data);
      if (Array.isArray(parsedArray)) {
        return parsedArray.join(' - ');
      } else {
        return '-';
      }
    },
    async setScanCustomFieldModalData(scanId){
      await this.setData({scanId});
      await this.$bvModal.show("UpdateScanCustomFieldsModal");
    }
  },
};
</script>

<style scoped>
  .grid-smiley-container {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 100%;
      height: 100%;
    }
    /* span svg path{
      fill: #ffffff;
    }
    span svg path:first-of-type {
      stroke: #ffffff;
    }
    .svg-div svg {
      width: 21px;
      height: 24px;
    } */
  }
  
  .rating-label-container {
    background-color: #103f5e;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .rating-star {
    /* position: absolute; */
    /* top: 15%; */
    /* margin: auto; */
    margin-top: auto;
    color: white;
    font-size: 10px;
  }

  .rating-label {
    /* position: absolute;
    top: 12%; */
    margin: auto;
    color: white;
    font-size: 10px;
  }
</style>

<style lang="scss">
.dashboardMasterGrid .dx-datagrid {
  height: unset !important;
}
div#subGrid {
  .font-weight-bolder {
    height: 12px;
    display: flex;
    align-items: center;
    // justify-content: center;
  }
  // .tooltip-inner {
  //   position: absolute;
  //   top: 42px;
  //   inset-inline-start: 24px;
  //   padding: 16px !important;
  //   width: 152px !important;
  // }
  .smiley-text {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    margin: auto 0 !important;
  }
}
</style>